import React, { Fragment } from 'react';

import useTotalOdd from './useTotalOdd';
import useValidTotalOddProps from './useValidTotalOddProps';

import './totalOdd.scss';

interface Props {
    betslipBetId: string;
}

const TotalOdd: React.FC<Props> = ({ betslipBetId }) => {
    const props = useTotalOdd({ betslipBetId });

    if (!props) return null;

    const { formattedTotalOdd } = props;

    return <div styleName="container">{formattedTotalOdd}</div>;
};

const ValidateTotalOdd: React.FC = () => {
    const { betslipBetId } = useValidTotalOddProps();

    if (!betslipBetId) return null;

    return <TotalOdd betslipBetId={betslipBetId} />;
};

export default ValidateTotalOdd;
